import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RequireAuth from "./components/routing/RequireAuth";
import AppLayout from "./components/layout/AppLayout";
import DashboardPage from "./pages/DashboardPage";
import UsersPage from "./pages/UsersPage";
import OrganizersPage from "./pages/OrganizersPage";
import EventsPage from "./pages/EventsPage";
import OrdersPage from "./pages/OrdersPage";
import PayoutsPage from "./pages/PayoutsPage";
import SettingsPage from "./pages/SettingsPage";
import AuditLogsPage from "./pages/AuditLogsPage";
import LoginPage from "./pages/LoginPage";
import NewsPage from "./pages/NewsPage";
import HelpPage from "./pages/HelpPage";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="organizers" element={<OrganizersPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="payouts" element={<PayoutsPage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
